














import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    "imports-table": () =>
      import("@/components/app/admin/imports/importsTable.vue")
  }
})
export default class AdminImports extends Vue {
  // Methods
  public openNewImportModal() {
    return this.$store.dispatch("ui/open/slideModal", {
      config: {
        component: () =>
          import("@/components/app/admin/imports/newImportModal.vue"),
        canCancel: ["button"],
        parent: this
      }
    });
  }
}
